import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/dev-movio/src/app/about/components/AboutContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/dev-movio/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/dev-movio/src/components/Header.tsx");
